<div class="errorContainer">
  <span>{{ data?.message }}</span>
  @if (data.snackType === 'Error') {
    <img src="../../../assets/icon/tick-circle-error.svg" />
  }
  @if (data.snackType === 'Success') {
    <img src="../../../assets/icon/tick circle good.svg" />
  }
  @if (data.snackType === 'Info') {
    <img src="../../../assets/icon/tick circle info.svg" />
  }
  @if (data.snackType === 'Warn') {
    <img src="../../../assets/icon/tick circle alert.svg" />
  }
</div>
